export const RELATIVE_TIMES = {
  pastSuffix: "قبل", // in arabic language this is a prefix
  now: "الان",
  s: {
    plural: "ثانية",
  },
  mm: {
    singular: "دقيقة",
    double: "دقيقتين",
    plural: "دقائق",
  },
  hh: {
    singular: "ساعة",
    double: "ساعتين",
    plural: "ساعات",
  },
  dd: {
    singular: "يوم",
    double: "يومين",
    plural: "أيام",
  },
  ww: {
    singular: "اسبوع",
    double: "اسبوعين",
    plural: "اسابيع",
  },
  MM: {
    singular: "شهر",
    double: "شهرين",
    plural: "أشهر",
  },
  yy: {
    singular: "سنة",
    double: "سنتين",
    plural: "سنوات",
  },
};

export const SPEC_ICONS = {
  beds: "v1/bed-king",
  livings: "v1/couch",
  wc: "v1/bath",
  area: "v1/area",
  type: "v1/pinned-note",
  street_width: "v1/street",
};
export const SPEC_ALT = {
  beds: "عدد الغرف",
  livings: "عدد الصالات",
  wc: "عدد الحمامات",
  area: "المساحة",
  type: "النوع",
  street_width: "عرض الشارع",
};

export const MINI_CAT_ICONS_MAP = {
  // Apartment or Big Flat
  1: ["area", "beds", "livings", "wc"],

  //Daily Renting
  101: ["area", "beds", "livings", "wc"],
  102: ["area", "beds", "livings", "wc"],
  103: ["area", "beds", "wc"],
  105: ["area"],
  106: ["area"],
  107: ["area"],
  108: ["area"],

  22: ["area", "beds", "wc", "street_width"],
  4: ["area", "beds", "livings", "wc"],
  6: ["area", "beds", "livings", "wc"],
  // Villa, Small House, Lounge
  3: ["area", "beds", "livings", "wc"],
  5: ["area", "beds", "livings", "wc"],
  9: ["area", "beds", "livings", "wc"],
  10: ["area", "beds", "livings", "wc"],
  11: ["area", "beds", "livings", "wc"],
  13: ["area", "beds", "livings", "wc"],
  // Store,Farm,Office, Warehouse
  8: ["area"],
  20: ["area"],
  12: ["area"],
  14: ["area"],
  17: ["area"],
  // Building
  7: ["area", "apts", "stores", "type"],
  16: ["area", "apts", "stores", "type"],
  // Land
  2: ["area", "street_width", "type"],
  15: ["area", "street_width", "type"],
};

// TODO: Think of handling this in the i18n layer
export const SPEC_VALUES = {
  type: {
    1: "سكني",
    2: "تجاري",
    3: "سكني/تجاري",
  },
};

export const URL_LEVELS = {
  CATEGORY: "CATEGORY",
  CITY: "CITY",
  DIRECTION: "DIRECTION",
  DISTRICT: "DISTRICT",
  LISTING: "LISTING",
};

export const TESTING_TARGET = "test";

export const TYPES_KEYFIELD_MAP = {
  CityType: "uri",
  DirectionType: "uri",
  DistrictType: "path",
};

export const PAGE_TITLES = {
  downloadPage: "تنزيل برنامج عقار | تطبيق عقار",
  forgotPasswordPage: "استرجاع كلمة العبور | تطبيق عقار",
  loginPage: "تسجيل الدخول | تطبيق عقار",
  signUpPage: "انشاء حساب | تطبيق عقار",
  partnersPage: "شركاء النجاح | تطبيق عقار",
  servicesPage: "الخدمات | تطبيق عقار",
  termsPage: "اتفاقية الاستخدام | تطبيق عقار",
};

export const CATEGORIES_HAS_STATS_DICTIONARY = {
  1: true,
  2: true,
  3: true,
};

export const CITIES_HAS_STATS_DICTIONARY = {
  21: { label: "الرياض", uri: "الرياض" },
  66: { label: "جدة", uri: "جدة" },
  18: { label: "الدمام", uri: "الدمام" },
  94: { label: "مكة المكرمة", uri: "مكة-المكرمة" },
  41: { label: "المدينة المنورة", uri: "المدينة-المنورة" },
  12: { label: "الخبر", uri: "الخبر" },
};

export const APP_ID = 879992882;
export const DEFAULT_STATS_CITY_ID = 21;

export const VALID_PAYMENT_SERVICES = [
  "packages",
  "fees",
  "ejar-fees",
  "ejar-ecrs-fees",
  "purchase-user",
  "corporate-package",
  "boost-listing",
  "red-services",
];

export const AUTH_SERVICES = [
  "packages",
  "purchase-user",
  "corporate-package",
  "boost-listing",
  "red-services",
];

export const VIDEO_ORIENTATION = "1280x720";
export const RED_CATEGORIES_IDS = [0, 6, 22, 3, 2];
export const STATUS_MAP = {
  SOON: "قريباً",
  AVAILABLE: "متاح",
  SOLD: "مباع",
};

export const TYPE_MAP = {
  OFF_PLAN: "على الخارطة",
  READY: "وحدات جاهزة",
};

export const RNPL_SERVICES_LINK = {
  owner:
    "https://help.aqar.fm/ar/articles/9445558-%D8%AE%D8%AF%D9%85%D8%A9-%D8%AA%D8%B3%D8%A7%D9%87%D9%8A%D9%84-%D9%84%D9%84%D9%85%D8%A4%D8%AC%D8%B1%D9%8A%D9%86",
  tenants:
    "https://help.aqar.fm/ar/articles/9445543-%D8%AE%D8%AF%D9%85%D8%A9-%D8%AA%D8%B3%D8%A7%D9%87%D9%8A%D9%84-%D9%84%D9%84%D9%85%D8%B3%D8%AA%D8%A3%D8%AC%D8%B1",
  harajTenent: "https://help.aqar.fm/ar/articles/12082693",
};

export const LOCAL_STORAGE_LICENSE_KEY = "addListingLicenseNumber";

export const RNPL_PROVIDERS = {
  rize: {
    name: "Rize",
    ar_name: "رايز",
    ar_tc: "https://rize.sa/terms-conditions/",
    ar_pp: "https://rize.sa/privacy-policy/",
  },
  ejari: {
    name: "Ejari",
    ar_name: "إيجاري",
    ar_tc: "https://ejari.sa/ar/tnc",
    ar_pp: "https://ejari.sa/ar/pp",
  },
};

export const QUERY_PARAM_VALUES = {
  disableRnpl: "disable_rnpl",
  disableRnplConfirm: "confirm_disable_rnpl",
  successfulEdit: "successful_edit",
  editDiscountMode: "edit_discount_mode",
};
